<template>
  <div id="app">
    <div v-if="paytype" class="head-shadow">
      <div class="header head-lg">
        <div @click="refresh" class="cursor-pointer"><img height="70px" src="./assets/img/logo.png" alt=""></div>
        <ul class="ul-outer ul-header">
          <li v-for="(item, index) in headerList" :key="item.label">
            <span :class="{ 'active': id == item.id }" class="hoverActive" @click="gotourl(item.url, index)">{{
              item.label }}</span>
            <!-- <div @click="gotourl(item.url, index)">{{ item.japname }}</div> -->
          </li>
        </ul>
        <div class="expireTime">
          <div style="margin-right: 10px;height: 24px;">
            <svg t="1766369159843" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="9936" width="24" height="24">
              <path
                d="M0.118 512C0.118 794.684 229.284 1023.882 512 1023.882c282.688 0 511.882-229.2 511.882-511.882C1023.882 229.284 794.688 0.118 512 0.118 229.284 0.118 0.118 229.284 0.118 512z"
                fill="#FC6E51" p-id="9937"></path>
              <path
                d="M490.662 42.764c0 11.778 9.544 21.338 21.338 21.338 11.78 0 21.324-9.56 21.324-21.338 0-11.78-9.544-21.34-21.324-21.34-11.792 0-21.338 9.56-21.338 21.34zM490.662 981.206c0 11.778 9.544 21.338 21.338 21.338 11.78 0 21.324-9.56 21.324-21.338 0-11.78-9.544-21.308-21.324-21.308-11.792-0.002-21.338 9.528-21.338 21.308zM258.902 116.278c5.888 10.216 18.934 13.714 29.148 7.81 10.186-5.874 13.686-18.934 7.794-29.12-5.888-10.214-18.932-13.684-29.132-7.81-10.2 5.876-13.7 18.934-7.81 29.12zM728.138 929.03c5.874 10.184 18.934 13.684 29.12 7.81 10.214-5.906 13.714-18.934 7.808-29.15-5.872-10.216-18.932-13.684-29.118-7.81-10.214 5.904-13.682 18.932-7.81 29.15zM94.97 295.862c10.202 5.874 23.244 2.376 29.134-7.81 5.888-10.216 2.388-23.244-7.81-29.15-10.202-5.874-23.246-2.374-29.134 7.81-5.888 10.216-2.39 23.246 7.81 29.15zM907.692 765.066c10.216 5.904 23.246 2.406 29.148-7.81 5.876-10.186 2.376-23.246-7.808-29.12-10.218-5.904-23.246-2.406-29.15 7.81-5.906 10.186-2.408 23.248 7.81 29.12zM42.764 533.306c11.78 0 21.34-9.53 21.34-21.306 0-11.78-9.56-21.34-21.34-21.34-11.778 0-21.322 9.56-21.322 21.34 0 11.778 9.544 21.306 21.322 21.306zM981.208 533.306c11.808 0 21.338-9.53 21.338-21.306 0-11.78-9.53-21.34-21.338-21.34-11.748 0-21.308 9.56-21.308 21.34-0.002 11.778 9.558 21.306 21.308 21.306zM116.294 765.066c10.2-5.874 13.7-18.934 7.81-29.12-5.89-10.216-18.934-13.714-29.134-7.81-10.202 5.874-13.7 18.934-7.81 29.12 5.888 10.216 18.934 13.714 29.134 7.81zM929.032 295.862c10.184-5.904 13.684-18.934 7.808-29.15-5.902-10.184-18.932-13.684-29.148-7.81-10.216 5.906-13.714 18.934-7.81 29.15 5.904 10.184 18.93 13.682 29.15 7.81zM295.846 929.03c5.89-10.216 2.39-23.246-7.794-29.15-10.214-5.874-23.26-2.406-29.148 7.81-5.89 10.216-2.39 23.244 7.81 29.15 10.2 5.872 23.244 2.372 29.132-7.81z"
                fill="#E9573F" p-id="9938"></path>
              <path
                d="M512 128.088c-11.792 0-21.338 9.528-21.338 21.306v353.764L240.532 753.288a21.328 21.328 0 1 0 30.148 30.182L527.074 527.06a21.208 21.208 0 0 0 6.25-15.058V149.394c0-11.778-9.544-21.306-21.324-21.306z"
                fill="#434A54" p-id="9939"></path>
              <path
                d="M765.066 116.308c5.906-10.216 2.406-23.276-7.808-29.15-10.186-5.874-23.246-2.404-29.12 7.81-5.874 10.186-2.404 23.246 7.81 29.12 10.186 5.904 23.248 2.406 29.118-7.78z"
                fill="#E9573F" p-id="9940"></path>
              <path
                d="M1006.106 725.264c-32.898-75.296-108.068-127.972-195.516-127.972-87.45 0-162.622 52.676-195.52 127.972l-17.778 21.338v63.986c0 117.786 95.51 213.294 213.296 213.294 117.816 0 213.292-95.51 213.292-213.294v-63.986l-17.774-21.338z"
                fill="#F6BB42" p-id="9941"></path>
              <path
                d="M1023.882 746.602c0 117.786-95.476 213.294-213.292 213.294-117.788 0-213.296-95.51-213.296-213.294s95.51-213.294 213.296-213.294c117.816-0.002 213.292 95.508 213.292 213.294z"
                fill="#FFCE54" p-id="9942"></path>
              <path
                d="M810.59 661.278c-11.78 0-21.34 9.56-21.34 21.338v127.972c0 11.778 9.56 21.338 21.34 21.338 11.778 0 21.338-9.56 21.338-21.338v-127.972c0-11.778-9.56-21.338-21.338-21.338z"
                fill="#E8AA3D" p-id="9943"></path>
            </svg>
          </div>
          <span>{{ expireTime }}</span>
        </div>
        <div v-if="!gameName1" class="logins opacityhover08" @click="openLogin">Login
          <!-- <div>ログイン</div> -->
        </div>
        <div v-if="gameName1" @click="openInfo" class="info">{{ gameName1 }}</div>
      </div>

      <div class="header-mobile head-md">
        <div @click="refresh"><img height="45px" src="./assets/img/logo.png" alt=""></div>
        <ul v-if="!gameName1" class="ul-outer">
          <li @click="openLogin">Login</li>
        </ul>
        <li class="info" @click="openInfo" v-if="gameName1">{{ gameName1 }}</li>
      </div>
    </div>

    <div :class="isad ? 'app-con' : ''">
      <router-view />
    </div>

    <div class="foot" v-if="paytype">
      <div class="foot-con">
        <div class="foot-main">
          <div class="foot-brand">
            <div class="foot-logo">CTG NET</div>
            <p class="foot-tagline">Top up once and play every game on CTG NET — instant delivery, secure payments
              and 24/7 support.</p>
            <div @click="gotourl('/contact')" class="foot-btn">Contact Us</div>
          </div>
          <div class="foot-col">
            <div class="foot-1">Company</div>
            <ul class="foot-links">
              <li @click="gotourl('/')">Home</li>
              <li @click="gotourl('/aboutUs')">About Us</li>
              <li @click="gotourl('/games')">Games</li>
              <li @click="gotourl('/join')">Join Us</li>
            </ul>
          </div>
          <div class="foot-col">
            <div class="foot-1">More</div>
            <ul class="foot-links">
              <li @click="gotourl('/privacyPolicy')">Privacy Policy</li>
              <li @click="gotourl('/termsofUse')">Terms of Use</li>
              <li @click="gotourl('/refundPolicy')">Refund Terms</li>
            </ul>
          </div>
          <div class="foot-col">
            <div class="foot-1">Contact</div>
            <div class="foot-contact">Name: CTG NET LIMITED</div>
            <div class="foot-contact">Address: RM 5042, 5/F, YAU LEE CENTRE, NO. 45, HOI YUEN ROAD, KWUN TONG, KOWLOON,
              HONG KONG</div>
            <div class="foot-contact">Email: service@ctggaming.com</div>
            <div class="foot-contact">business@ctggaming.com</div>
            <div class="foot-1 foot-1-pay">We Accept</div>
            <div class="pay-row">
              <div class="pay-chip"><img src="./assets/img/visa1.png" alt="Visa"></div>
              <div class="pay-chip"><img src="./assets/img/mastercard.png" alt="Mastercard"></div>
              <div class="pay-chip"><img src="./assets/img/American.png" alt="American Express"></div>
              <div class="pay-chip"><img src="./assets/img/discover.jpg" alt="Discover"></div>
              <div class="pay-chip"><img src="./assets/img/jcb.png" alt="JCB"></div>
            </div>
          </div>
        </div>
        <div class="foot-last">© 2026 CTG NET LIMITED. All Rights Reserved.</div>
      </div>
    </div>

    <loginDialog ref="dialog" @childEvent="tiemUp"></loginDialog>
    <accountDialog ref="accountDialog"></accountDialog>

  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import loginDialog from './components/loginDialog/index.vue'
import accountDialog from './components/accountDialog/index.vue'
export default {
  name: 'app',
  data() {
    return {
      web: this.$utils.isDesktop(),
      id: '1',
      expireTime: '0',
      headerList: [
        { label: 'Home', url: '/', id: "1", japname: 'ホーム' },
        { label: 'About us', url: '/aboutUs', id: "2", japname: '会社について' },
        { label: 'Games', url: '/games', id: "3", japname: 'ゲーム' },
        { label: 'Join Us', url: '/join', id: "4", japname: '入社案内' },
        { label: 'Privacy Policy', url: '/privacyPolicy', id: "5", japname: 'プライバシーポリシー' },
        { label: 'Terms of Use', url: '/termsofUse', id: "6", japname: '利用規約' },
        { label: 'Contact Us', url: '/contact', id: "7", japname: 'お問い合わせ' },
        { label: 'Refund Terms', url: '/refundPolicy', id: "8", japname: 'お問い合わせ' },
      ],
      payTypeValue: 'USD',
      options: [{
        value: 'USD',
        label: 'USD'
      }, {
        value: 'EUR',
        label: 'EUR'
      }],
      isRefresh: true,
      paytype: true,
      dialogVisible: false,
      isad: null

    }
  },
  components: { loginDialog, accountDialog },
  computed: {
    ...mapState({
      gameName1: state => state.user.gameName1,
    })
  },
  methods: {
    ...mapMutations(['getnumGame', 'payTypeMutations']),
    handleOpen() { },
    handleClose() { },
    openLogin() {
      this.$refs.dialog.show()
    },
    refresh() {
      this.$router.push('/')
      sessionStorage.setItem('numGame', '1')
      this.getnumGame()
    },
    gotourl(path, index) {
      this.id = index + 1
      this.$router.push(path)
    },
    gotoFaceBook(url) {
      window.open(url)
    },
    openInfo() {
      this.$refs.accountDialog.show()
    },
    tiemUp() {
      let gameName = sessionStorage.getItem('gameName')
      this.$axios.get(`/game/expire/time/getExpireTime/ctggaming/${gameName}`).then((res) => {
        res = res.data
        this.expireTime = res.result.expireTime
        if (res.result.expireTime == '0') {
          sessionStorage.removeItem('isPay')
        } else {
          sessionStorage.setItem('isPay', 'pass')
        }
      })
    },
    payTypeFun(val) {
      this.payTypeMutations(val)
      sessionStorage.setItem('currencyType', val)
    },
  },
  mounted() {
    if (sessionStorage.getItem('currencyType')) {
      this.payTypeValue = sessionStorage.getItem('currencyType')
    } else {
      this.payTypeValue = 'USD'
    }
    let gameName = sessionStorage.getItem('gameName')
    if (gameName) {
      sessionStorage.setItem('isPay', 'pass')
      this.tiemUp()
    }
  },
  beforeUpdate() {
    if (this.$route.path == '/callbackpay2' || this.$route.path == '/pay' || this.$route.path == '/payHtml/Failed'
      || this.$route.path == '/payHtml/Successful' || this.$route.path == '/payHtml/Paymentlinkhasexpired'
    ) {
      this.isad = ''
      this.paytype = false
    } else {
      this.isad = '1'
      this.paytype = true
    }
  },
}
</script>
<style lang="less">
.ul-outer {
  font-size: 14px;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  li {
    margin-right: 28px;

    span,
    div {
      cursor: pointer;
      color: #C3CADB;
      font-weight: 600;
      font-family: 'Inter', -apple-system, 'Segoe UI', Roboto, Arial, sans-serif;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      text-align: center;
      transition: color 0.2s;
    }
  }
}

.home-icon {
  width: 1260px;
  margin: 0 auto;

  .home-img {
    position: fixed;
    top: 20px;
    width: 66px;
    height: 66px;
    margin-left: -34px;
    border-radius: 50%;
    background: #ecf5ff;
    cursor: pointer;

    svg {
      width: 100%;
      height: 100%;
      padding: 10px;
      box-sizing: border-box;
    }
  }
}

.logins {
  font-family: 'aachenb';
  font-size: 18px;
  cursor: pointer;
  padding: 10px 28px;
  background: #FFFF53;
  color: #030E22;
  border-radius: 10px;
  transition: background 0.2s;
}

.logins:hover {
  background: #FFFA80;
}

.info {
  font-size: 22px;
  color: #FFF;
}

.head-shadow {
  position: fixed;
  z-index: 9999;
}

.app-con {
  min-height: calc(100vh - 360px - 50px);
  margin-top: 78px;
  // background-color: #292929;
  background-image: url('./assets/img/new/background.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-clip: content-box;
  // background-clip:convert(fill-available) ;
  // background-clip: ceil();
}

.imgGames {
  width: 150px;
  position: absolute;
  right: 76px;
  bottom: 14px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  position: fixed;
  top: 0;
  height: 78px;
  padding: 0 40px;
  box-sizing: border-box;
  background: rgba(3, 14, 34, 0.92);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  z-index: 9999;
}

.ul-header {
  flex: 1;
  justify-content: center;
  margin: 0 32px;
}

.icon-icons {
  display: flex;
  margin: 15px auto;
  justify-content: center;
  align-items: center;
}

.icon-baoder {
  width: 0px;
  height: 20px;
  border: 1px solid #FFF;
  margin-left: 15px;
}


.foot {
  background: #030E22;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff;
}

.foot-con {
  max-width: 1200px;
  margin: 0 auto;
  padding: 48px 32px 0;
}

.foot-main {
  display: grid;
  grid-template-columns: 1.4fr 0.8fr 0.9fr 1.4fr;
  gap: 40px;
  padding-bottom: 40px;
}

.foot-logo {
  font-family: 'aachenb';
  font-size: 28px;
  margin-bottom: 14px;
}

.foot-tagline {
  color: #8F97AB;
  font-size: 14px;
  line-height: 1.7;
  margin: 0 0 20px;
  max-width: 260px;
}

.foot-1 {
  font-family: 'aachenb';
  font-size: 16px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #FFFFFF;
  margin-bottom: 16px;
}

.foot-1-pay {
  margin-top: 22px;
}

.foot-links {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    color: #A8B0C3;
    font-size: 14px;
    padding: 6px 0;
    cursor: pointer;
    transition: color 0.2s;
  }

  li:hover {
    color: #FFFF53;
  }
}

.foot-contact {
  color: #A8B0C3;
  font-size: 14px;
  line-height: 1.7;
  margin-bottom: 10px;
}

.pay-row {
  display: grid;
  grid-template-columns: repeat(3, 62px);
  gap: 10px;
}

.pay-chip {
  width: 62px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 5px 4px;

  img {
    height: 24px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
    display: block;
  }
}

.foot-last {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  text-align: left;
  color: #8F97AB;
  font-size: 13px;
  padding: 18px 0 22px;
}

.foot-btn {
  background: #FFFF53;
  border-radius: 8px;
  width: 140px;
  text-align: center;
  line-height: 46px;
  color: #030E22;
  font-family: 'aachenb';
  font-size: 20px;
  cursor: pointer;
  transition: background 0.2s;
}

.foot-btn:hover {
  background: #FFFA80;
}

@media (width < 768px),
(min-resolution: 3dppx) and (width < 768px) {
  .app-con {
    min-height: auto;
    margin-top: 56px;
    background-color: #292929;
  }

  .foot-con {
    padding: 32px 20px 0;
  }

  .foot-main {
    grid-template-columns: 1fr;
    gap: 28px;
    padding-bottom: 28px;
  }

  .foot-1 {
    margin-bottom: 10px;
  }

  .foot-last {
    font-size: 12px;
  }

  .info {
    margin-right: 14px;
  }

}

.header-mobile {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  position: fixed;
  top: 0;
  background: rgba(3, 14, 34, 0.95) !important;
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  z-index: 9999;
  padding: 0px 4px 0 14px;

  .ul-outer {
    li {
      padding: 4px 8px;
      background: #FFFF53;
      border-radius: 8px;
      margin-right: 12px;

      span {
        color: #000;
        font-family: 'aachenb';
        font-size: 18px;
      }
    }
  }
}

.active {
  color: #FFFF53 !important;
  border-bottom: 2px solid #FFFF53;
  padding-bottom: 2px;
}

.hoverActive {
  transition: color 0.2s;
}

.hoverActive:hover {
  color: #FFFF53 !important;
  border-bottom: 2px solid #FFFF53;
  padding-bottom: 2px;
}

.expireTime {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 16px;
  font-size: 15px;
  color: #E6EAF4;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  margin-right: 10px;
}
</style>
